module.exports = __webpack_public_path__ + "337b2fcf9f5f2ff72b1afaec4a8f17c1.svg";